import {BrickSnake2000Symbol, SymbolArgs} from "./BrickSnake2000Symbol";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {gsap} from "gsap";

export class CollectorSymbol extends BrickSnake2000Symbol {
    private landAnimation:PIXI.spine.Spine;
    public multiplierValue:number
    private multiplier:PIXI.BitmapText;

    constructor(args:SymbolArgs) {
        super(args);

        this.landAnimation =
            new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.FS_COLLECTOR));
        this.view.addChild(this.landAnimation);

        this.multiplierValue = args.symbolSize;

        this.multiplier = new PIXI.BitmapText(`x${this.multiplierValue}`, {
            fontName: BrickSnake2000GameAssets.BITMAP_FONT_FS_MULTI_GREEN,
            fontSize : 40,
        });
        (<PIXI.Point>this.multiplier.anchor).set(0.5, 0.5);
        this.view.addChild(this.multiplier);
        this.makeMultiFit();
    }

    private makeMultiFit():void {
        this.multiplier.scale.set(1,1);
        if (this.multiplier.width > 110) {
            const newScale = 110 / this.multiplier.width;
            this.multiplier.scale.set(newScale, newScale);
        }
    }

    public getLandAnimation(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.landAnimation.alpha = 1;
                this.mainSprite.alpha = 0;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.landAnimation, 0, `TA_Land`))
            .add(() => {
                this.landAnimation.alpha = 0;
                this.mainSprite.alpha = 1;
                this.moveToNormalLayer();
            })
    }

    public updateValue(newValue:number) {
        this.multiplierValue = newValue;
        this.multiplier.text = `x${this.multiplierValue}`;
        this.makeMultiFit();
    }

    public setBrokenLevel(level:number):void {
        const loader = BrickSnake2000.assetLoader;
        const assets = BrickSnake2000GameAssets;
        const newSprite = new PIXI.Sprite(loader.getTextures(assets.getSymbolStateTexturePath(this.symbolName,
                                                                                              `_Step_${level}`))[0]);
        newSprite.anchor.set(0.5, 0.5);
        this.view.removeChild(this.mainSprite);
        this.view.addChildAt(newSprite, 0);

        this.mainSprite = newSprite;
    }
}
